export { UserAccess as default } from './UserAccess';
